(function () {
  const MAX_DOTS = 4;
  const SWIPE_TRIGGER_PX = 30;
  const HORIZONTAL_LOCK_PX = 8;

  function getImages(el) {
    try { return JSON.parse(el.dataset.images || "[]"); }
    catch { return []; }
  }

  function bucketIndexToImageIndex(len, bucketIdx) {
    if (len <= MAX_DOTS) return bucketIdx;
    const bucketSize = len / MAX_DOTS;
    return Math.floor(bucketIdx * bucketSize);
  }

  function imageIndexToBucketIndex(len, imgIdx) {
    if (len <= MAX_DOTS) return imgIdx;
    const bucketSize = len / MAX_DOTS;
    return Math.min(MAX_DOTS - 1, Math.floor(imgIdx / bucketSize));
  }

  function renderDots(el, images) {
    // nutze IMMER den vorhandenen Container
    let dots = el.querySelector(".quick-gallery__dots");
    if (!dots) {
      dots = document.createElement("div");
      dots.className = "quick-gallery__dots";
      el.appendChild(dots);
    }

    const dotCount = Math.min(MAX_DOTS, images.length);

    dots.innerHTML = Array.from({ length: dotCount }).map((_, i) =>
      `<button class="quick-gallery__dot" type="button" data-bucket="${i}" aria-label="Bild ${i+1}"></button>`
    ).join("");

    dots.addEventListener("click", (e) => {
      const btn = e.target.closest(".quick-gallery__dot");
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      const bucket = parseInt(btn.dataset.bucket, 10);
      const targetIndex = bucketIndexToImageIndex(images.length, bucket);
      setImage(el, images, targetIndex, true);
    }, { passive: false });
  }

  function setActiveDot(el, len, idx) {
    const activeBucket = imageIndexToBucketIndex(len, idx);
    el.querySelectorAll(".quick-gallery__dot")
      .forEach((d, i) => d.classList.toggle("is-active", i === activeBucket));
  }

  function setImage(el, images, index, userInitiated) {
    const img = el.querySelector(".quick-gallery__img");
    if (!img || !images.length) return;

    const safeIndex = (index + images.length) % images.length;
    el.dataset.qgIndex = safeIndex;

    img.src = images[safeIndex];
    img.removeAttribute("srcset");

    setActiveDot(el, images.length, safeIndex);

    if (userInitiated) {
      el.classList.add("qg-touched");
      clearTimeout(el._qgTouchedT);
      el._qgTouchedT = setTimeout(() => el.classList.remove("qg-touched"), 600);
    }
  }

  function initCard(el) {
    const images = getImages(el);
    if (images.length < 2) return;

    el.dataset.qgIndex = el.dataset.qgIndex || 0;
    renderDots(el, images);
    setActiveDot(el, images.length, parseInt(el.dataset.qgIndex, 10));
  }

  function boot() {
    document.querySelectorAll(".quick-gallery").forEach(initCard);
  }

  // -----------------------------
  // GLOBAL SWIPE CAPTURE
  // -----------------------------
  let activeEl = null;
  let activeImages = [];
  let startX = 0, startY = 0;
  let isSwiping = false;

  function findGalleryFromPoint(x, y) {
    const topEl = document.elementFromPoint(x, y);
    if (!topEl) return null;

    const g1 = topEl.closest?.(".quick-gallery");
    if (g1) return g1;

    const card = topEl.closest?.(".card-wrapper, .card, .grid__item");
    if (!card) return null;

    return card.querySelector(".quick-gallery");
  }

  document.addEventListener("touchstart", (e) => {
    const t = e.touches[0];
    const el = findGalleryFromPoint(t.clientX, t.clientY);
    if (!el) { activeEl = null; return; }

    activeEl = el;
    activeImages = getImages(el);
    if (activeImages.length < 2) { activeEl = null; return; }

    isSwiping = false;
    startX = t.clientX;
    startY = t.clientY;
  }, { passive: true, capture: true });

  document.addEventListener("touchmove", (e) => {
    if (!activeEl) return;

    const t = e.touches[0];
    const dx = t.clientX - startX;
    const dy = t.clientY - startY;

    if (Math.abs(dx) > HORIZONTAL_LOCK_PX && Math.abs(dx) > Math.abs(dy)) {
      isSwiping = true;
      if (e.cancelable) e.preventDefault();
      e.stopPropagation();
    }
  }, { passive: false, capture: true });

  document.addEventListener("touchend", (e) => {
    if (!activeEl) return;

    const t = e.changedTouches[0];
    const dx = t.clientX - startX;
    const idx = parseInt(activeEl.dataset.qgIndex || "0", 10);

    if (isSwiping && Math.abs(dx) > SWIPE_TRIGGER_PX) {
      setImage(activeEl, activeImages, idx + (dx < 0 ? 1 : -1), true);
    }

    activeEl = null;
    activeImages = [];
    isSwiping = false;
  }, { passive: true, capture: true });

  document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", boot);
})();
